import { FinishingOptionsTab, OptionAndHeadline } from "../../../types/ContentfulTypes";

export const showFinishingOptions = (tab?: FinishingOptionsTab) =>
  tab?.finishingOptions
    ? tab?.finishingOptions?.filter((value: OptionAndHeadline) => value.property)?.length > 0
    : false;
